/**
 * @file 问答相关接口
 * @author zhanghaohan
 */
import 'whatwg-fetch';
import {spyRequest as request} from '../log/index';
import API from './api';


/*
 * 添加问答库类型
*/
export const getFaqQuestionTypeAdd = params => {
    return request(
        API.GET_V2_FAQ_QUESTION_TYPE_ADD, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/*
 * 删除问答库类型
*/
export const getFaqQuestionTypeDel = params => {
    return request(
        API.GET_V2_FAQ_QUESTION_TYPE_DEL, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/*
 * 获取问答库类型列表
*/
export const getFaqQuestionType = params => {
    return request(
        API.GET_V2_FAQ_QUESTION_TYPE, {
            method: 'POSTJSON',
            body: params
        }
    );
};



/**
 * 获取问答对
 * @returns Promise
 */
export const getFaq = async params => {
    return request(
        API.GET_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/**
 * 根据商品获取问答对
 * @returns Promise
 */
export const getV2Faq = async params => {
    return request(
        API.GET_V2_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 删除问答对
 * @returns Promise
 */
export const delFaq = async params => {
    return request(
        API.DEL_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/**
 * 删除某个商品库的问答对
 * @returns Promise
 */
export const delV2Faq = async params => {
    return request(
        API.DEL_V2_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 新增问答对
 * @returns Promise
 */
export const addFaq = async params => {
    return request(
        API.ADD_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/**
 * 新增问答对到商品库
 * @returns Promise
 */
export const addV2Faq = async params => {
    return request(
        API.ADD_V2_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 编辑问答对
 * @returns Promise
 */
export const updateFaq = async params => {
    return request(
        API.UPDATE_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 移动问答问答对
 * @returns Promise
 */

export const updateV2Faq = async params => {
    return request(
        API.UPDATE_V2_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/**
 * 文心通过剧本生成问答对
 * @returns Promise
 */
export const ernieScript2Faq = async params => {
    return request(
        API.ERNIE_SCRIPT_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 文心通过商品生成问答对
 * @returns Promise
 */
export const ernieGoods2Faq = async params => {
    return request(
        API.ERNIE_GOODS_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/**
 * 文心通过线索生成问答对
 * @returns Promise
 */
export const ernieCustomFaq = async params => {
    return request(
        API.ERNIE_CUSTOM_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 查询文心问答生成进度
 * @returns Promise
 */
export const getErnieFaqProgress = async params => {
    return request(
        API.ERNIE_FAQ_PROGRESS, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 文心问答生成结果
 * @returns Promise
 */
export const getErnieFaqList = async params => {
    return request(
        API.ERNIE_FAQ_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 文心问答生成结果已处理（添加、放弃、停止生成）
 * @returns Promise
 */
export const updateErnieFaqUse = async params => {
    return request(
        API.ERNIE_FAQ_USE_UPDATE, {
            method: 'POSTJSON',
            body: params
        }
    );
};
export const updateErnieSetting = async params => {
    return request(
        API.ERNIE_FAQ_SETTING, {
            method: 'POSTJSON',
            body: params
        }
    );
};
export const getErnieSetting = async params => {
    return request(
        API.GET_ERNIE_FAQ_SETTING, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 启用问答对
 * @returns Promise
 */
export const enableFaq = async params => {
    return request(
        API.ENABLE_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 禁用问答对
 * @returns Promise
 */
export const disableFaq = async params => {
    return request(
        API.DISABLE_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取互动配置信息
 * @returns Promise
 */
export const getInteractRules = async params => {
    return request(
        API.GET_INTERACT_RULES, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 检查问答对
 * @returns Promise
 */
export const checkFaq = async params => {
    return request(
        API.CHECK_FAQ, {
            method: 'POSTJSON',
            body: params
        }
    );
};
export const checkFaqByFile = async params => {
    return request(
        API.CHECK_FAQ_BYFILE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 预约直播获取是否展示文心问答授权
 * @returns Promise
 */
export const getIfShowErnieFaqAuth = async params => {
    return request(
        API.IS_SHOW_FAQ_ERNIE_AUTH, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 查询一言优化数量
 * @returns Promise
 */
export const getFaqOptimizeNum = async params => {
    return request(
        API.GET_FAQ_OPTIMIZE_NUM, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 查询一言优化列表
 * @returns Promise
 */
export const getFaqOptimizeList = async params => {
    return request(
        API.GET_FAQ_OPTIMIZE_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 一言优化正确标记
 * @returns Promise
 */
export const setFaqOptimizeMark = async params => {
    return request(
        API.GET_FAQ_OPTIMIZE_MARK, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 添加到问答库
 * @returns Promise
 */
export const addFaqOptimize = async params => {
    return request(
        API.ADD_FAQ_OPTIMIZE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 问答对标记为已退出
 * @returns Promise
 */
export const faqMarkExit = async params => {
    return request(
        API.FAQ_MARK_EXIT, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/**
 * 推荐问答对
 * @returns Promise
 */
export const faqRecommendList = async params => {
    return request(
        API.FAQ_RECOMMEND_LIST, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 智能回复问答总数
 * @returns Promise
 */
export const aiAnswerTotal = async params => {
    return request(
        API.AI_ANSWER_TOTAL, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 智能回复列表
 * @returns Promise
 */
export const getAiAnswerList = async params => {
    return request(
        API.AI_ANSWER_PAGE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取问答图片
 * @returns Promise
 */
export const getQaImageList = async params => {
    return request(
        API.GET_QA_IMAGE, {
            method: 'POSTJSON',
            body: params
        }
    );
};
